import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './timer.scss';

export interface IPropsTimer {
  expiration: number;
  isRequesSuccess: boolean;
}

const Timer: React.FC<IPropsTimer> = ({ expiration, isRequesSuccess }): JSX.Element => {
  const { t } = useTranslation();

  const [timeLeft, setTimeLeft] = useState(0);

  const getPadTime = (time: number) => {
    return time.toString().padStart(2, '0');
  };

  const minutes = getPadTime(Math.floor(timeLeft / 60));
  const seconds = getPadTime(timeLeft - Number(minutes) * 60);

  useEffect(() => {
    const interval = setInterval(() => setTimeLeft((timeLeft) => (timeLeft >= 1 ? timeLeft - 1 : 0)), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setTimeLeft(expiration);
  }, [expiration, isRequesSuccess]);

  return (
    <p className={`timer ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
      {t('TIME.WAITING_FOR_PAYMENT')} (00:{minutes}:{seconds})
    </p>
  );
};

export default Timer;
